module.exports = __webpack_public_path__ + "assets/img/icon2.9c126dbf.png";